import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    headerUrl: "/loading.gif",
    salonName: "SALON TICKET",
    salonId: "",
    isActiveMessage: false,
  },
  getters: {
    idToken: (state: any) => {
      return state.auth.token;
    },
    id: (state: any) => {
      return state.auth.user.id;
    },
    user: (state: any) => {
      return state.auth.user;
    },
    activeMessage: (state: any) => {
      return state.isActiveMessage;
    },
    salonId: (state: any) => {
      return state.salonId;
    },
  },
  mutations: {
    setHeaderUrl(state, url) {
      state.headerUrl = url;
    },
    setSalonName(state, name) {
      state.salonName = name;
    },
    setSalonId(state, salon_id) {
      state.salonId = salon_id;
    },
    setActiveMessage(state, payload: boolean) {
      state.isActiveMessage = payload;
    },
  },
  actions: {
    actionSetHeaderUrl(context, url) {
      context.commit("setHeaderUrl", url);
    },
    actionSetSalonName(context, name) {
      context.commit("setSalonName", name);
    },
    actionSetSalonId(context, salon_id) {
      context.commit("setSalonId", salon_id);
    },
    activeMessage(context, payload) {
      context.commit("setActiveMessage", payload);
    },
  },
  modules: {
    auth: auth,
  },
  plugins: [createPersistedState()],
});
